import { BaseModel } from "./baseModel";

export interface IFaqLanguage {
    name?: string;
    sample?: any;
    description?: string;
}

export interface IFaqCategory{
    _id?: string;
    position?: string;
    code: string;
    name : {
        en: string,
        es: string,
        pt: string
    }
}

export const FaqCategories: Array<IFaqCategory> = [
    { name: {en: "About hotel", es: "Sobre el hotel", pt: "Sobre o hotel"}, code: "1"},
    { name: {en: "Reservation", es: "Reserva", pt: "Reserva"}, code: "2"},
    { name: {en: "Cancellation", es: "Cancelamento", pt: "Cancelamento"}, code: "3"}
]

export interface IFaq extends BaseModel{
   id?: string;
   category : IFaqCategory;
   en : IFaqLanguage;
   es : IFaqLanguage;
   pt : IFaqLanguage;
   required: boolean;
   type?: string;
   name: string;
   segment?: string;
   roles: string[];
   position?: number;
}

export interface IFaqValue extends BaseModel{
   id?: string;
   workspaceId: string;
   faqId : string;
   criteria : any; //aqui fica hotelId
   en : any;
   es : any;
   pt : any;
   position?: number;
}